import { CustomError } from './customError';

export class ConditionalRequestFailedError extends CustomError { }
